import { beforeRouteEnterAction } from '@router/router.utils.js'

export default {
  path: '/subscription-workflow-management',
  component: () => import(/* webpackChunkName: "subscription-workflow-management" */ './SubscriptionWorkflow'),
  meta: {
    requiresAuth: true,
    pageTitle: 'Subscription workflow management'
  },
  beforeEnter: beforeRouteEnterAction
}
